export const cleanUpObject = (customData: any) =>
  Object.fromEntries(
    Object.entries(customData).filter(
      ([_, value]) => value !== '' && !Number.isNaN(value),
    ),
  );
